import { ExpressionResolverFn } from "../../core/types";

class NonSystemicExpressionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NonSystemicExpressionError";
  }

  static create(message: string): NonSystemicExpressionError {
    return new NonSystemicExpressionError(message);
  }
}

export const nonSystemicResolver: ExpressionResolverFn = async (config) => {
  const { externalResources } = config;

  if (!externalResources?.taskMeta) {
    throw NonSystemicExpressionError.create(
      "Task meta information is not available in external resources"
    );
  }

  const taskMeta = externalResources.taskMeta as {
    isSystemGenerated?: boolean;
  };

  if (typeof taskMeta.isSystemGenerated !== "boolean") {
    throw NonSystemicExpressionError.create(
      "isSystemGenerated field is missing or invalid in task meta"
    );
  }

  // Return true if task is non-systemic (not system-generated)
  return !taskMeta.isSystemGenerated;
};
